import React from "react";
import { useTranslation } from "react-i18next";

function FooterNote() {
  const { t } = useTranslation();
  return (
    <div className="footer-note">
      <div className="wrap">
        <h4>{t("footer.Note title")}</h4>
        <p>{t("footer.Note text")}</p>
      </div>
    </div>
  );
}

export default FooterNote;
